import { Component, QueryList, ViewChildren, OnInit, Output, Inject, OnDestroy, ViewChild } from '@angular/core';
import { ConsultaDetalhada } from 'src/app/persistences/consulta-detalhada';
import { ConfigService } from 'src/app/services/config.service';
import { EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PesquisaAvancadaCustomizadaComponent } from '../genericos/pesquisa-avancada-customizada/pesquisa-avancada-customizada.component';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { PesquisaService } from 'src/app/services/pesquisa.service';
import { Veiculo } from 'src/app/persistences/veiculo';
import { SnackbarManager } from 'src/app/managers/snackbar-manager';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ConsultaCustomizada } from 'src/app/persistences/consulta-customizada';
import { ConsultaCustomizadaService } from 'src/app/services/consulta-customizada.service';

@Component({
  selector: 'app-pesquisa-avancada',
  templateUrl: './pesquisa-avancada.component.html',
  styleUrls: ['./pesquisa-avancada.component.css']
})
export class PesquisaAvancadaComponent implements OnInit, OnDestroy{

	@Output() aplicarFiltrosEmitter = new EventEmitter<ConsultaDetalhada>();
	@Output() fecharEmitter = new EventEmitter();

	@ViewChildren(PesquisaAvancadaCustomizadaComponent)
	pesquisaAvancadaCustomizadaComponent!: QueryList<PesquisaAvancadaCustomizadaComponent>;

	@ViewChild(MatAutocompleteTrigger) trigger!: MatAutocompleteTrigger;

	@ViewChild('montadoraComp') montadoraComp: PesquisaAvancadaCustomizadaComponent;
	@ViewChild('modeloComp') modeloComp: PesquisaAvancadaCustomizadaComponent;
	@ViewChild('complementoComp') complementoComp: PesquisaAvancadaCustomizadaComponent;
	@ViewChild('injecaoComp') injecaoComp: PesquisaAvancadaCustomizadaComponent;
	@ViewChild('motorComp') motorComp: PesquisaAvancadaCustomizadaComponent;
	@ViewChild('transmissaoComp') transmissaoComp: PesquisaAvancadaCustomizadaComponent;
 
	public consultaCustomizada = new ConsultaCustomizada;

    public anos = [];
	identificador = 'cntMontadora';
	campoChaveDoFiltro = 'cd_montadora';
	complementoConsulta = '';
	public consultaDetalhada = new ConsultaDetalhada();
	public utilizaPesquisaAvancada: boolean;
	public temaPadrao: string;
	public filtrado: boolean;
	public filtroLimpo: boolean;
	public placa: string;
	placaControl = new FormControl('');
	veiculo: Veiculo;
	utilizaFraga = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: ConsultaDetalhada,
		private configService: ConfigService,
		public dialogRef: MatDialogRef<PesquisaAvancadaComponent>,
		private pesquisaService: PesquisaService,
	){ }

	ngOnInit(): void {
		this.temaPadrao = this.configService.getConfig().getTemaPadrao;
		this.consultaDetalhada = this.data; 
		if(this.configService.getConfig().getUtilizaPesquisaAvancadaVeiculos === "S"){
			this.utilizaPesquisaAvancada = true;
		}else{
			this.utilizaPesquisaAvancada = false;
		}

		this.configService.getConfigByCdEntrada(3280).subscribe((config) => {
			this.utilizaFraga = config.vlEntrada === 'S' ? true : false;
		})

		this.getAnos();

		this.placaControl.valueChanges
		.pipe(
			debounceTime(500),
			distinctUntilChanged()
		)
		.subscribe((valor) => {
			this.buscarVeiculoPorPlaca(valor);
		});
	}

	ngOnDestroy(): void {
		const quantidade = Object.values(this.consultaDetalhada)
		.filter(valor => valor !== '0' && valor !== undefined && valor !== null && valor !== '' && valor.length !== 0).length;
		
		const resultadoDialog = {
			consulta: this.filtroLimpo ? new ConsultaDetalhada() : this.consultaDetalhada,
			qtdFiltros: quantidade,
			filtrado: this.filtrado
		}
		
		if(quantidade === 0){
			if( !this.filtrado ){
				this.dialogRef.close(); 
			}
		}else{
			if( this.filtrado ){
				this.dialogRef.close(resultadoDialog); 
			}else{
				this.dialogRef.close();
			}
		}
	}

	getAnos(){
		const anoAtual = new Date().getFullYear(); 
		for (let ano = 1900; ano <= anoAtual+1; ano++) {
			this.anos.push(ano); 
		}
		this.anos.sort((a,b)=>{
			if(a > b){
				return -1
			}else{
				return 1
			}
		})
	}

    receberItemConsultaMontadora(itemConsulta) {
		this.consultaDetalhada.montadora = itemConsulta;
	}

	receberItemConsultaModelo(itemConsulta) {
		this.consultaDetalhada.modelo = itemConsulta;
	}

	receberItemConsultaComplemento(itemConsulta) {
		this.consultaDetalhada.complemento = itemConsulta;
	}

	receberItemConsultaAno(itemConsulta) {
		this.consultaDetalhada.anoInicial = itemConsulta;
	}

	receberItemConsultaInjecao(itemConsulta) {
		this.consultaDetalhada.injecao = itemConsulta;
	}

	receberItemConsultaMotor(itemConsulta) {
		this.consultaDetalhada.motor = itemConsulta;
	}

	receberItemConsultaTransmissao(itemConsulta) {
		this.consultaDetalhada.transmissao = itemConsulta;
	}

	limparFiltros() {
		this.filtrado = false;
		this.filtroLimpo = true;
		this.consultaDetalhada = new ConsultaDetalhada();

		this.pesquisaAvancadaCustomizadaComponent.forEach((component) => {
			component.limpar();
		});

	}

	aplicarFiltros(){
		this.filtrado = true;
		const quantidade = Object.values(this.consultaDetalhada)
		.filter(valor => valor !== '0' && valor !== undefined && valor !== null && valor !== '' && valor.length !== 0).length;

		const resultadoDialog = {
			consulta: this.consultaDetalhada,
			qtdFiltros: quantidade
		}

		this.dialogRef.close(resultadoDialog); 
    }

	fechar(){
		this.filtrado = false;
		this.dialogRef.close();
	}

	buscarVeiculoPorPlaca(placa: string) {
		const placaLimpa = placa?.trim();
		if (!placaLimpa) return;

		this.pesquisaService.buscarVeiculoPlaca(placaLimpa).subscribe((veiculo) => {
			this.veiculo = veiculo;
			this.preencherFiltrosComVeiculo(veiculo);
		});
	}

	preencherFiltrosComVeiculo(veiculo: Veiculo) {
		this.consultaDetalhada.montadora = veiculo.cdMontadora;
		this.consultaDetalhada.modelo = veiculo.cdModelo;
		this.consultaDetalhada.complemento = veiculo.cdComplemento;
		this.consultaDetalhada.injecao = veiculo.cdInjecao;
		this.consultaDetalhada.motor = veiculo.cdMotor;
		this.consultaDetalhada.transmissao = veiculo.cdTransmissao;

		setTimeout(() => {
			this.montadoraComp.pesquisaEspecifica(veiculo.cdMontadora);
			this.modeloComp.pesquisaEspecifica(veiculo.cdModelo);
			this.complementoComp.pesquisaEspecifica(veiculo.cdComplemento);
			this.injecaoComp.pesquisaEspecifica(veiculo.cdInjecao);
			this.motorComp.pesquisaEspecifica(veiculo.cdMotor);
			this.transmissaoComp.pesquisaEspecifica(veiculo.cdTransmissao);
		}, 0);
	}
}
